import React from 'react'

function forgotpass() {
  return (
    <div>
      
    </div>
  )
}

export default forgotpass
